export enum RolePermission {
  Read = 'read',
  Write = 'write'
}

export enum InventoryModule {
  Procurement = 'procurement',
  InventoryManagement = 'inventory_management',
  InventoryManagment = 'inventory_management',
  KitchenRequisition = 'kitchen_requisition',
  WastageReport = 'wastage_report',
  ItemConversion = 'item_conversion',
  MealAddOnPricing = 'meal_add_on_pricing',
  IngredientMapping = 'ingredient_mapping',
  UploadsAndEvidence = 'uploads_and_evidence',
  MainStoreTransfer = 'main-store-transfer',
  KitchenStoreTransfer = 'kitchen-store-transfer',
  Transfers = 'transfers',
  PaymentModule = 'payment',
  User = 'user',
  Role = 'role'
}

export type PermissionType = {
  id?: string;
  module: InventoryModule | string;
  action: RolePermission | string;
  created_at?: string;
  updated_at?: string;
};

export type RoleAuthorizationState = {
  roleName?: string;
  roleId?: string;
  permissions: PermissionType[];
};

export type PermissionCheck = {
  module: InventoryModule | string;
  actions?: RolePermission | RolePermission[];
  options?: {
    match?: 'any' | 'all';
  };
};
